
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmingmachinemanufacures() {



  const cardData =
  {
    keyword: 'Patient Warming Machine Manufacturers in India',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Machine Manufacturers in India',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading Patient Warming Machine Manufacturer in India, offering advanced thermal care solutions designed to maintain optimal patient body temperature during surgical and critical care procedures. Our state-of-the-art warming machines utilize cutting-edge technology to provide consistent and controlled heat, effectively preventing hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across India, our machines are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior patient warming machines that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Top Patient Warming Machine Manufacturers in India",
    "description": "Pharmacle Health Care Private Limited stands out as one of the most trusted patient warming machine manufacturers in India, delivering advanced solutions that help maintain patient body temperature during surgeries and critical care. Our systems are designed with precision and built to meet the demanding standards of Indian and international hospitals."
  },
  {
    "title": "India’s Trusted Source for Patient Warming Machines",
    "description": "As a leading manufacturer, Pharmacle Health Care Private Limited offers innovative patient warming machines equipped with intelligent temperature sensors and user-friendly controls. Our devices are used in operation theaters, ICUs, and recovery units across India to reduce hypothermia-related complications and enhance patient comfort."
  },
  {
    "title": "Reliable Manufacturers of Surgical Patient Warming Equipment",
    "description": "We specialize in producing high-performance surgical patient warming machines that ensure consistent heat distribution and efficient thermal regulation. Pharmacle Health Care Private Limited’s machines are built to support healthcare professionals with effective and safe temperature management solutions during complex procedures."
  },
  {
    "title": "Advanced Patient Warming Machines – Made in India",
    "description": "Proudly manufactured in India, our patient warming machines combine medical innovation with durable engineering. Pharmacle Health Care Private Limited ensures every device meets global quality benchmarks, providing Indian healthcare providers with affordable and efficient solutions for thermal care."
  },
  {
    "title": "Top-Quality Medical Patient Warming Devices for Indian Hospitals",
    "description": "Pharmacle Health Care Private Limited’s patient warming devices are crafted with cutting-edge components to deliver precise, stable heating. They are essential for preventing perioperative hypothermia, promoting recovery, and enhancing clinical outcomes in both private and government hospitals."
  },
  {
    "title": "Patient Warming Solutions for Modern Indian Healthcare",
    "description": "Our warming machines are tailored for the specific needs of Indian hospitals and surgical centers. Pharmacle Health Care Private Limited’s focus on energy-efficient, compact, and safe-to-use equipment makes us a preferred partner for thermal management in the healthcare industry."
  },
  {
    "title": "Nationwide Supplier of Patient Warming Machines in India",
    "description": "Pharmacle Health Care Private Limited serves a wide network of hospitals and clinics across India, offering prompt support and delivery of high-quality patient warming machines. Our reputation for consistent performance and customer-centric service makes us a leading name in the medical equipment industry."
  },
  {
    "title": "Affordable and Effective Patient Warming Equipment in India",
    "description": "Combining affordability with advanced technology, Pharmacle Health Care Private Limited manufactures warming machines that help maintain normothermia during all types of medical procedures. Our equipment is easy to operate, maintain, and integrate into existing hospital infrastructure."
  },
  {
    "title": "Custom-Built Patient Warming Machines for Diverse Clinical Needs",
    "description": "From pediatric units to trauma care and general surgery, Pharmacle Health Care Private Limited designs custom patient warming systems to match the diverse needs of healthcare facilities across India. Our machines offer flexible configurations and compatibility with a range of warming accessories."
  },
  {
    "title": "Pharmacle Health Care Private Limited – India’s Premier Manufacturer of Patient Warming Systems",
    "description": "With years of expertise and innovation, Pharmacle Health Care Private Limited has earned its place as a premier manufacturer of patient warming machines in India. We provide the tools that healthcare providers need to ensure patient safety, comfort, and fast recovery during critical medical procedures."
  }
],

"services": [
    {
        "name": "Patient Warming Machine Manufacturers India",
        "description": "Pharmacle Health Care is a leading manufacturer of patient warming machines in India, designed to maintain optimal body temperature during medical procedures. Our machines use advanced technology to prevent hypothermia and ensure patient comfort and safety during surgeries, recovery, and critical care. Trusted by healthcare providers across India, our patient warming machines contribute to better patient outcomes and a more efficient recovery process."
    },
    {
        "name": "India Medical Warming Machine Suppliers",
        "description": "We are trusted suppliers of medical warming machines in India, providing essential equipment for maintaining safe body temperatures during medical treatments. These machines are designed to prevent hypothermia and ensure a stable and comfortable thermal environment for patients. Pharmacle Health Care’s medical warming machines are highly reliable and are used in hospitals, surgical centers, and other healthcare facilities throughout India."
    },
    {
        "name": "Patient Heat Therapy Device Manufacturers",
        "description": "Pharmacle Health Care manufactures patient heat therapy devices designed to regulate and maintain body temperature during medical treatments. These devices are essential for preventing hypothermia and ensuring patient safety and comfort during surgery, recovery, and critical care. Our heat therapy devices are built with advanced technology to provide consistent and reliable warming solutions."
    },
    {
        "name": "Forced Air Warming Machine Suppliers",
        "description": "We supply forced air warming machines that are designed to provide controlled warmth during medical treatments. Using advanced technology, these machines circulate warm air around the patient's body to maintain a stable body temperature, preventing hypothermia during surgeries and recovery. Our forced air warming machines are trusted by healthcare providers for their effectiveness in improving patient comfort and safety."
    },
    {
        "name": "Body Temperature Control Machines India",
        "description": "Pharmacle Health Care provides body temperature control machines in India, designed to regulate and maintain patient body temperature during medical procedures. These machines help prevent hypothermia and thermal instability, ensuring patient comfort and safety. Whether used in operating rooms, recovery units, or critical care settings, our body temperature control machines are essential for optimizing patient care."
    },
    {
        "name": "Hospital Thermal Warming Equipment",
        "description": "We offer hospital thermal warming equipment designed to provide safe and reliable body temperature regulation during medical procedures. This equipment is essential for preventing hypothermia and ensuring patient comfort in hospital settings. Our thermal warming devices are used across various medical specialties, including surgery, recovery, and critical care, to improve patient safety and recovery outcomes."
    },
    {
        "name": "India Patient Thermoregulation Machine Suppliers",
        "description": "Pharmacle Health Care is a leading supplier of patient thermoregulation machines in India, designed to regulate and maintain body temperature during medical treatments. These machines are vital for preventing hypothermia, promoting patient comfort, and ensuring the success of surgical procedures. Our thermoregulation machines are trusted by hospitals and healthcare providers for their precision, reliability, and ease of use."
    }
],
"tableData": [
    ["- Patient Warming Machine Manufacturers India", "- India Medical Warming Machine Suppliers"],
    ["- Patient Heat Therapy Device Manufacturers", "- Forced Air Warming Machine Suppliers"],
    ["- Body Temperature Control Machines India", "- Hospital Thermal Warming Equipment"],
    ["- India Patient Thermoregulation Machine Suppliers"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As leading Patient Warming Machine Manufacturers in India, we provide advanced warming technology that ensures precise temperature regulation during medical procedures. Our machines are designed to prevent hypothermia, improving patient safety and comfort during surgeries and treatments."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a comprehensive range of Patient Warming Machines in India, tailored to meet the needs of hospitals and clinics. Our systems include cutting-edge devices that maintain patient body temperature during surgeries, recovery, and other medical procedures."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warming Machines are manufactured to the highest standards of quality, ensuring durability and long-lasting performance. Each machine is thoroughly tested to ensure it meets rigorous safety and reliability standards in medical environments across India."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are our top priorities. Our Patient Warming Machines provide controlled warmth, preventing temperature-related complications such as hypothermia during critical medical procedures, ensuring patients receive the safest care possible."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Machines are designed to adapt to various healthcare settings across India. Whether in operating rooms, recovery areas, or intensive care units, our solutions offer flexibility and efficiency, ensuring patient comfort and safety throughout the treatment process."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Our Patient Warming Machines are designed for seamless integration with existing medical systems in India. These systems can be easily incorporated into hospitals or clinics, providing enhanced patient care without disrupting ongoing procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services to healthcare providers in India, helping them select the right Patient Warming Machines for their needs. Our dedicated support team ensures that the equipment operates at peak efficiency, providing maintenance and troubleshooting when necessary."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the heart of our mission. Our Patient Warming Machines are specifically designed to regulate temperature safely and effectively, ensuring that every patient in India receives the highest quality care."
    }
]



















  }

  const faqData = [
    {
      question: "Who are the top Patient Warming Machine manufacturers in India?",
      answer: "Pharmacle Health Care Private Limited is among the top Patient Warming Machine manufacturers in India, offering high-performance systems designed to maintain normothermia during surgeries and critical care procedures."
    },
    {
      question: "What types of Patient Warming Machines does Pharmacle Health Care offer?",
      answer: "Pharmacle Health Care provides Forced Air Warming Machines that work with warming blankets or pads to circulate warm air over the patient's body, ensuring safe and efficient temperature control."
    },
    {
      question: "Are Pharmacle’s Patient Warming Machines suitable for all medical settings?",
      answer: "Yes, these machines are designed for use in operating rooms, ICUs, recovery rooms, and other clinical environments where maintaining patient body temperature is crucial."
    },
    {
      question: "Can Pharmacle Health Care deliver Patient Warming Machines across India?",
      answer: "Yes, Pharmacle Health Care provides nationwide delivery and support, making their Patient Warming Machines accessible to healthcare facilities throughout India."
    },
    {
      question: "Does Pharmacle Health Care offer after-sales support for Patient Warming Machines?",
      answer: "Yes, they offer full after-sales support, including installation, training, and maintenance services to ensure long-term performance and safety."
    }
  ];
  
  const testimonialsData = [
    {
      text: "Pharmacle Health Care’s Patient Warming Machines have improved surgical outcomes and patient comfort in our facility. They are efficient and user-friendly.",
      name: "Dr. Arvind Rao, National Heart Institute"
    },
    {
      text: "We’re very satisfied with the performance and service from Pharmacle Health Care. Their warming systems are reliable and meet our hospital’s standards.",
      name: "Greenline Hospital, Bangalore"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Machine Manufacturers in India",
    "description": "Reliable Patient Warming Machine Manufacturers in India offering high-quality medical warming machines, forced air heat therapy devices, and thermal equipment for patient body temperature control in hospitals and surgical centers.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1163"
    }
  };
  
 
  

  

  return (
    <div>
 <Helmet>
    <title>Patient Warming Machine Manufacturers in India | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find top Patient Warming Machine Manufacturers in India. Supplying heat therapy devices, forced air warming machines, and hospital thermoregulation equipment. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Machine Manufacturers India, India Medical Warming Machine Suppliers, Patient Heat Therapy Device Manufacturers, Forced Air Warming Machine Suppliers, Body Temperature Control Machines India, Hospital Thermal Warming Equipment, India Patient Thermoregulation Machine Suppliers"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmingmachinemanufacures;